/**
 * PDF Material Component
 *
 * Displays PDF documents with download option.
 */

import { useTranslation } from 'react-i18next';
import { useMaterialUrl, type Material } from '@immopersian/common';
import { LoadingSpinner } from './shared/LoadingSpinner';
import { ErrorMessage } from './shared/ErrorMessage';
import { MaterialDescription } from './shared/MaterialDescription';
import { FileCard } from './shared/FileCard';
import { DocumentIcon } from './shared/Icons';

interface PdfMaterialProps {
  material: Material;
}

export function PdfMaterial({ material }: PdfMaterialProps) {
  const { t } = useTranslation();
  const { data, isLoading, error } = useMaterialUrl(material.id, material.type);

  if (isLoading) {
    return <LoadingSpinner message={t('courses.loadingDocument')} />;
  }

  if (error) {
    return <ErrorMessage message={error.message} />;
  }

  return (
    <>
      <MaterialDescription material={material} />
      <FileCard
        url={data?.url || ''}
        icon={<DocumentIcon />}
        label={t('courses.pdfDocument')}
        openLabel={t('courses.openPdf')}
      />
    </>
  );
}
